import LootInterface from 'app/interfaces/LootInterface';

export type LootboxPrizeType = 'points' | 'money' | 'frozen_money' | 'bonus' | 'recipe' | 'steam_skin' | 'unknown';

export const lootboxPrizeType = (loot: LootInterface): LootboxPrizeType => {
    switch (true) {
    case Number(loot.points_amount) > 0:
        return 'points';
    case Number(loot.money_amount) > 0:
        return 'money';
    case Number(loot.frozen_money_amount) > 0:
        return 'frozen_money';
    case loot.bonus === true || loot.bonus === false:
        return 'bonus';
    case Boolean(loot.recipe):
        return 'recipe';
    case Boolean(loot.steam_skin):
        return 'steam_skin';
    default:
        return 'unknown';
    }
};

export const hideCalculatedPrice = (loot: LootInterface): boolean => {
    const type = lootboxPrizeType(loot);

    return type === 'money' || type === 'bonus';
};
